import React from 'react';
import './footer.css';
import {
  FaFacebookF, FaLinkedinIn, FaInstagram, FaXTwitter,
  FaLocationDot, FaPhone, FaEnvelope
} from "react-icons/fa6";
import { Link } from 'react-router-dom';
import logo from '../assets/images/Loanonsalary_Logo.png';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-wave">
        <svg viewBox="0 0 1440 100">
          <path fill="#2c3e50" d="M0,32L48,42.7C96,53,192,75,288,80C384,85,480,75,576,74.7C672,75,768,85,864,90.7C960,96,1056,96,1152,80C1248,64,1344,32,1392,16L1440,0V100H0Z"></path>
        </svg>
      </div>

      <div className="container footer-container">
        <div className="footer-columns">

          {/* Logo and About */}
          <div className="footer-column glass-box">
            <img src={logo} alt="Loanontip Logo" className="footer-logo" />
            <p className="footer-text">
             Naman Finlease Pvt. Ltd is dedicated to empowering India’s salaried workforce by offering timely, trusted, and technology-driven lending solutions that simplify access to credit, support financial goals, and enable a more secure future.
            </p>
            {/* <div className="footer-social">
              <a href="#"><FaFacebookF /></a>
              <a href="#"><FaLinkedinIn /></a>
              <a href="#"><FaInstagram /></a>
              <a href="#"><FaXTwitter /></a>
            </div> */}
          </div>

          {/* Quick Links */}
          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul>
              {[
                ['Apply Loan', 'apply-now'],
                ['Contact Us', 'contact-us'],
                // ['Corporate Governance', 'corporate-governance'],
                // ['Fair Practice Code', 'fair-practice-code'],a
                // ['Interest Rate Policy', 'interest-rate-policy'],
                // ['Risk Management Policy', 'risk-management-policy'],
                // ['Career', 'career'],
              ].map(([label, path], index) => (
                <li key={index}>
                  <Link to={`/${path}`}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Pages */}
          <div className="footer-column">
            <h4>Pages</h4>
            <ul>
              {[
                // ['Terms and Conditions', 'terms-conditions'],
                // ['Privacy Policy', 'privacy-policy'],
                // ['Key Fact Statement', 'key-fact-statement'],
                // ['KYC and PMLA', 'kyc-and-pmla'],
                // ['Terms & Rates', 'terms-rates'],
                ['About Us', 'about-us'],
                ['FAQs', 'faqs'],
              ].map(([label, path], index) => (
                <li key={index}>
                  <Link to={`/${path}`}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-column">
            <h4>Contact Us</h4>
            <div className="footer-contact">
              <p><FaLocationDot className="icon" /><b> Registered Office: </b>S-370, Block S, Panchsheel Park South, Panchsheel Park, New Delhi, Delhi 110017.</p>
              <p><FaLocationDot className="icon" /> <b>Corporate Office: </b>1710, 17TH Floor, World Trade Tower, Sector 16, Noida, Uttar Pradesh.</p>
              <p><FaEnvelope className="icon" /> <a href="mailto:info@loanontip.com">info@loanonsalary.com</a></p>
              <p><FaPhone className="icon" /> <a href="tel:+910000000000">+91-0000000000</a></p>
            </div>
          </div>
        </div>

        <div className="footer-bottom mb-3">
          &copy; {new Date().getFullYear()} Naman Finlease Pvt. Ltd. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
